export default __webpack_public_path__ + "assets/images/308d0df9da7e15fefd5fa2422873e163.jpg";